export default "__VITE_ASSET__217S8S05__"